'use client';

import { useState } from 'react';
import clsx from 'clsx';
import LinkComponent from './LinkComponent';
import { type ProductPageHierarchyItem } from './productPageHierarchy';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

export type FeaturePageNavProps = {
  pageHierarchy: {
    pillarPage: ProductPageHierarchyItem;
    featurePages: ProductPageHierarchyItem[];
  };
};

export function FeaturePageNav({ pageHierarchy }: FeaturePageNavProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
    document.documentElement.style.isolation = !isMenuOpen ? 'isolate' : '';
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
    document.documentElement.style.isolation = '';
  };

  return (
    <div className="sticky top-0 z-[100] bg-dark-background text-gray-5">
      <div className="text-body max-w-section flex justify-between px-4 py-2">
        <li className="flex items-center">
          <LinkComponent href={pageHierarchy.pillarPage.href} className="font-bold">
            {pageHierarchy.pillarPage.title}
          </LinkComponent>
        </li>
        <button onClick={toggleMenu} className="flex h-11 items-center text-gray-5 lg:hidden">
          <ChevronDownIcon className={`h-5 w-5 transition-transform duration-300 ${isMenuOpen ? 'rotate-180' : ''}`} />
        </button>
        <div className="absolute bottom-0 left-0 right-0 lg:hidden">
          <ul
            className={clsx(
              'absolute left-0 right-0 top-full flex flex-col gap-4 overflow-hidden bg-dark-background transition-all duration-300 ease-in-out',
              isMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0',
            )}
          >
            {pageHierarchy.featurePages.map(item => (
              <li key={item.title} className="h-11 px-4 py-2" onClick={handleLinkClick}>
                <LinkComponent
                  href={item.href}
                  className="block w-full cursor-pointer"
                  activeClassName="text-gradle-blue"
                >
                  {item.title}
                </LinkComponent>
              </li>
            ))}
          </ul>
        </div>

        <ul className="hidden h-11 items-center gap-6 lg:flex">
          {pageHierarchy.featurePages.map(item => (
            <li className="grid place-items-center" key={item.title}>
              <LinkComponent href={item.href}>{item.title}</LinkComponent>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
